/**
 * Custom Horizontal Scroll Bar for Inclusions Table
 * Independent component that controls horizontal scrolling
 * Updated: Prevents drag scrolling when clicking on first column
 */

(function() {
    'use strict';

    // Custom Horizontal Scroll Bar Functionality
    function initCustomScrollBar() {
        const scrollBars = document.querySelectorAll('.custom-scroll-bar');
        
        // Initialize drag scrolling for inclusions-table-block
        initDragScrolling();
        
        function initDragScrolling() {
            const scrollableElements = document.querySelectorAll('.inclusions-table-block');
            
            scrollableElements.forEach(element => {
                let isDown = false;
                let startX;
                let scrollLeft;
                
                // Helper function to check if click is on first column
                function isFirstColumn(target) {
                    // Check if the clicked element is within a table
                    const td = target.closest('td, th');
                    if (!td) return false;
                    
                    // Get the parent row
                    const row = td.closest('tr');
                    if (!row) return false;
                    
                    // Check if this is the first cell in the row
                    const cells = Array.from(row.querySelectorAll('td, th'));
                    return cells.indexOf(td) === 0;
                }
                
                // Mouse events
                element.addEventListener('mousedown', (e) => {
                    // Check if clicking on first column
                    if (isFirstColumn(e.target)) {
                        return; // Don't initiate drag scroll
                    }
                    
                    // Only enable drag scrolling if there's actually overflow
                    if (element.scrollWidth <= element.clientWidth) return;
                    
                    isDown = true;
                    element.style.cursor = 'grabbing';
                    startX = e.pageX - element.offsetLeft;
                    scrollLeft = element.scrollLeft;
                    e.preventDefault();
                });
                
                element.addEventListener('mouseleave', () => {
                    isDown = false;
                    // Only set grab cursor if there's overflow
                    element.style.cursor = element.scrollWidth > element.clientWidth ? 'grab' : 'default';
                });
                
                element.addEventListener('mouseup', () => {
                    isDown = false;
                    // Only set grab cursor if there's overflow
                    element.style.cursor = element.scrollWidth > element.clientWidth ? 'grab' : 'default';
                });
                
                element.addEventListener('mousemove', (e) => {
                    if (!isDown) return;
                    e.preventDefault();
                    const x = e.pageX - element.offsetLeft;
                    const walk = (x - startX) * 0.75; // Scroll speed multiplier
                    element.scrollLeft = scrollLeft - walk;
                });
                
                // Touch events for mobile
                element.addEventListener('touchstart', (e) => {
                    // Check if touching first column
                    if (isFirstColumn(e.target)) {
                        return; // Don't initiate drag scroll
                    }
                    
                    if (element.scrollWidth <= element.clientWidth) return;
                    
                    isDown = true;
                    startX = e.touches[0].pageX - element.offsetLeft;
                    scrollLeft = element.scrollLeft;
                });
                
                element.addEventListener('touchmove', (e) => {
                    if (!isDown) return;
                    e.preventDefault();
                    const x = e.touches[0].pageX - element.offsetLeft;
                    const walk = (x - startX) * 1;
                    element.scrollLeft = scrollLeft - walk;
                });
                
                element.addEventListener('touchend', () => {
                    isDown = false;
                });
                
                // Update cursor style on hover to show grab only when not over first column
                element.addEventListener('mouseover', (e) => {
                    if (isDown) return; // Don't change cursor while dragging
                    
                    if (element.scrollWidth > element.clientWidth && !isFirstColumn(e.target)) {
                        element.style.cursor = 'grab';
                    } else {
                        element.style.cursor = 'default';
                    }
                });
                
                // Set initial cursor style based on overflow
                element.style.cursor = element.scrollWidth > element.clientWidth ? 'grab' : 'default';
                
                // Update cursor on window resize (in case overflow changes)
                window.addEventListener('resize', () => {
                    if (!isDown) {
                        element.style.cursor = element.scrollWidth > element.clientWidth ? 'grab' : 'default';
                    }
                });
            });
        }
        
        scrollBars.forEach(scrollBar => {
            const targetClass = scrollBar.dataset.target;
            const targetElement = document.querySelector(`.${targetClass}`);
            const track = scrollBar.querySelector('.custom-scroll-bar__track');
            const thumb = scrollBar.querySelector('.custom-scroll-bar__thumb');
            
            if (!targetElement || !track || !thumb) {
                return;
            }
            
            let isDragging = false;
            let startX = 0;
            let scrollLeft = 0;
            
            // Calculate thumb size and position
            function updateThumb() {
                const targetWidth = targetElement.scrollWidth;
                const visibleWidth = targetElement.clientWidth;
                const scrollRatio = visibleWidth / targetWidth;
                const thumbWidth = Math.max(track.clientWidth * scrollRatio, 40); // Min 40px
                
                thumb.style.width = thumbWidth + 'px';
                
                // Update thumb position based on scroll
                const scrollPercent = targetElement.scrollLeft / (targetWidth - visibleWidth);
                const maxThumbLeft = track.clientWidth - thumbWidth;
                thumb.style.left = (scrollPercent * maxThumbLeft) + 'px';
            }
            
            // Update thumb when target scrolls
            targetElement.addEventListener('scroll', updateThumb);
            
            // Handle thumb dragging
            thumb.addEventListener('mousedown', (e) => {
                isDragging = true;
                startX = e.clientX - thumb.offsetLeft;
                thumb.classList.add('dragging');
                e.preventDefault();
            });
            
            // Handle track clicking
            track.addEventListener('click', (e) => {
                if (e.target === thumb) return;
                
                const trackRect = track.getBoundingClientRect();
                const clickX = e.clientX - trackRect.left;
                const thumbWidth = thumb.clientWidth;
                const newThumbLeft = Math.max(0, Math.min(clickX - thumbWidth / 2, track.clientWidth - thumbWidth));
                
                const scrollPercent = newThumbLeft / (track.clientWidth - thumbWidth);
                const maxScroll = targetElement.scrollWidth - targetElement.clientWidth;
                targetElement.scrollLeft = scrollPercent * maxScroll;
            });
            
            // Handle mouse move and up
            document.addEventListener('mousemove', (e) => {
                if (!isDragging) return;
                
                const newLeft = e.clientX - startX;
                const maxLeft = track.clientWidth - thumb.clientWidth;
                const clampedLeft = Math.max(0, Math.min(newLeft, maxLeft));
                
                const scrollPercent = clampedLeft / maxLeft;
                const maxScroll = targetElement.scrollWidth - targetElement.clientWidth;
                targetElement.scrollLeft = scrollPercent * maxScroll;
                
                e.preventDefault();
            });
            
            document.addEventListener('mouseup', () => {
                if (isDragging) {
                    isDragging = false;
                    thumb.classList.remove('dragging');
                }
            });
            
            // Touch events for mobile
            thumb.addEventListener('touchstart', (e) => {
                isDragging = true;
                startX = e.touches[0].clientX - thumb.offsetLeft;
                thumb.classList.add('dragging');
                e.preventDefault();
            });
            
            document.addEventListener('touchmove', (e) => {
                if (!isDragging) return;
                
                const newLeft = e.touches[0].clientX - startX;
                const maxLeft = track.clientWidth - thumb.clientWidth;
                const clampedLeft = Math.max(0, Math.min(newLeft, maxLeft));
                
                const scrollPercent = clampedLeft / maxLeft;
                const maxScroll = targetElement.scrollWidth - targetElement.clientWidth;
                targetElement.scrollLeft = scrollPercent * maxScroll;
                
                e.preventDefault();
            });
            
            document.addEventListener('touchend', () => {
                if (isDragging) {
                    isDragging = false;
                    thumb.classList.remove('dragging');
                }
            });
            
            // Initial setup
            updateThumb();
            
            // Update on window resize
            window.addEventListener('resize', updateThumb);
        });
    }
    
    // Advanced bubble pulse animation for tick--included elements
    function pulseIncludedTick(tick, delay = 0) {
        
        // Create a pulse element behind the tick
        const pulseElement = document.createElement('div');
        pulseElement.className = 'tick-pulse';
        pulseElement.style.cssText = `
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            height: 100%;
            background: var(--purple, #8B5CF6);
            border-radius: 50%;
            opacity: 0;
            transform: translate(-50%, -50%) scale(0);
            z-index: -1;
            pointer-events: none;
        `;
        
        // Make sure tick has relative positioning
        const tickStyle = window.getComputedStyle(tick);
        if (tickStyle.position === 'static') {
            tick.style.position = 'relative';
        }
        
        tick.appendChild(pulseElement);
        
        // Create the timeline animation
        const tl = gsap.timeline({ delay: delay });
        
        // Step 1: Scale down the tick slightly (smaller compression)
        tl.to(tick, {
            scale: 0.9,
            duration: 0.3,
            ease: "power2.out"
        });
        
        // Step 2: Show and scale the pulse (overlapping with step 1) - much smaller pulse
        tl.to(pulseElement, {
            scale: 0.6,
            opacity: 0.8,
            duration: 0.4,
            ease: "power2.out"
        }, '-=0.4');
        
        // Step 3: Bounce the tick back to normal size with elastic ease (gentler bounce)
        tl.to(tick, {
            scale: 1,
            duration: 0.8,
            ease: "elastic.out(1.5, 0.4)"
        });
        
        // Step 4: Expand and fade out the pulse (overlapping with step 3) - smaller expansion
        tl.to(pulseElement, {
            scale: 1.3,
            opacity: 0,
            duration: 0.8,
            ease: "expo.out",
            onComplete: () => {
                // Clean up the pulse element
                if (pulseElement.parentNode) {
                    pulseElement.parentNode.removeChild(pulseElement);
                }
            }
        }, '-=0.8');
    }
    
    // Initialize table row animations with tick pulse integration
    function initInclusionsTableAnimations() {
        const tables = document.querySelectorAll('.inclusions-table__table');
        
        tables.forEach(table => {
            const thead = table.querySelector('thead');
            const tbody = table.querySelector('tbody');
            const tfoot = table.querySelector('tfoot');
            const rows = tbody ? tbody.querySelectorAll('tr') : [];
            
            if (rows.length === 0) {
                return;
            }
            
            // Track if rows have been pulsed already (only care about TR elements)
            let rowsHaveBeenPulsed = false;
            
            // Set initial states
            gsap.set([thead, ...rows, tfoot], {
                opacity: 0,
                y: 30
            });
            
            // Create ScrollTrigger batch for table elements
            ScrollTrigger.batch([thead, ...rows, tfoot], {
                onEnter: (elements) => {
                    
                    elements.forEach((element, index) => {
                        let delay = 0;
                        
                        if (element.tagName === 'THEAD') {
                            delay = 0;
                        } else if (element.tagName === 'TR') {
                            // Find the index of this row among all rows
                            const rowIndex = Array.from(rows).indexOf(element);
                            delay = 0.15 + (rowIndex * 0.15);
                        } else if (element.tagName === 'TFOOT') {
                            delay = 0.15 + (rows.length * 0.15) + 0.2;
                        }
                        
                        // Check if we should pulse for this specific TR element
                        const shouldPulse = element.tagName === 'TR' && !rowsHaveBeenPulsed;
                        
                        // Animate the row in
                        gsap.to(element, {
                            opacity: 1,
                            y: 0,
                            duration: 0.6,
                            ease: "power2.out",
                            delay: delay,
                            onComplete: () => {
                                // When row animation completes, pulse any included ticks (ONLY on first scroll)
                                if (element.tagName === 'TR' && !rowsHaveBeenPulsed) {
                                    const includedTicks = element.querySelectorAll('.inclusions-table__tick--included');
                                    includedTicks.forEach((tick, tickIndex) => {
                                        pulseIncludedTick(tick, 0); // All ticks in same row pulse simultaneously
                                    });
                                }
                                
                                // Mark that we've pulsed after ALL rows are processed
                                if (element.tagName === 'TFOOT') {
                                    rowsHaveBeenPulsed = true;
                                }
                            }
                        });
                    });
                },
                trigger: table,
                start: "top 80%"
            });
        });
    }
    
    // Wait for GSAP and ScrollTrigger to be available
    function waitForGSAP() {
        return new Promise((resolve) => {
            if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
                resolve();
            } else {
                const checkGSAP = setInterval(() => {
                    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
                        clearInterval(checkGSAP);
                        resolve();
                    }
                }, 100);
            }
        });
    }
    
    // Initialize animations
    const initAnimations = () => {
        waitForGSAP().then(() => {
            // Initialize table animations with integrated tick pulses
            initInclusionsTableAnimations();
        });
    };
    
    // Initialize custom scroll bars when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initCustomScrollBar();
            initAnimations();
        });
    } else {
        initCustomScrollBar();
        initAnimations();
    }

})();